export interface IUser {
    Token?: string;
    Username: string;
    Fullname?: string;
    Password: string;
    TxtPassword?: string;
    CreateDate?: string;
    Userphone?: string;
    UserEmail?: string;
    LstPermission?: string[];
    Status?: number;
    Level: string;
}

export interface IUserLocal {
    ExpireDate: number;
    ExpireDateTxt: string;
    Fullname: string;
    InsertDate: number;
    InsertDateTxt: string;
    Perm: string[];
    Token: string;
    UserCreateDate: string;
    Username: string;
    Userphone: string;
    UserEmail: string;
    Level?: Level;
}
export interface IBaseWrapper<T> {
    Result: number;
    Data: T;
    Message: string;
}

export interface IDataLogin {
    Token: string;
    InsertDate: number;
    InsertDateTxt: number;
    ExpireDate: number;
    ExpireDateTxt: string;
    Username: string;
    Userphone: string;
    UserCreateDate: string;
    Perm: [];
    Fullname: string;
}

export enum Level {
    ADMIN = 'ADMIN',
    USER = 'USER',
}

